import { Avatar, Stack } from '@mui/material';

import { useGetEmployeeProfilePicture } from '@/api/REST/employees';
import { Icon } from '@/components/ui/Icon';
import { areaIcons } from '@/constants/areaIcons';

interface ProfilePictureCellProps {
  userId: number;
}

export const ProfilePictureCell = ({ userId }: ProfilePictureCellProps) => {
  const { data: pictureUrl } = useGetEmployeeProfilePicture(String(userId));

  return (
    <Stack direction="row">
      {pictureUrl ? (
        <Avatar src={pictureUrl} size="small" />
      ) : (
        <Icon name={areaIcons.employees} size="large" color="secondary" />
      )}
    </Stack>
  );
};
